import UpdateCart from '../components/updateCart';
import QuantitySpinnerInput from '../components/quantitySpinnerInput';

const wooCommerceCartObject = {};

export default {
  init() {
    wooCommerceCartObject.updateCart = new UpdateCart(this);
  },

  finalize() {
    wooCommerceCartObject.quantitySpinnerInput = new QuantitySpinnerInput(
      this,
      wooCommerceCartObject.updateCart.update
    );
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce-cart.js